<template>
    <div>
        <page
        ref="page"
        :name="name"
        :forms="forms"
        :params="params"
        :parent="parent"
        :id="id"
        :interface="interface"
        @action-button="actionButton"
        @composition-button-click="compositionButtons"
        ></page>
        <representative-file-modal
        v-if="renderFileModal"
        :buttonName="buttonName"
        :params="params"
        @close-modal="closeModal"
        >

        </representative-file-modal>
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import RepresentativeFileModal from './RepresentativeFileModal.vue'
const {
  page
} = JtCrud

  @Component({
    mixins: [page],
    name: 'Representative',
    components: {
      RepresentativeFileModal,
      page
    },
    props: {
      name: String,
      forms: { type: Array, required: true },
      params: Object,
      parent: Object,
      id: String,
      interface: String
    }
  })
class RepresentativePage extends Vue {
    buttonName = ''
    renderFileModal = false
    params = {}

    closeModal () {
      this.buttonName = ''
      this.params = {}
      this.renderFileModal = false
    }

    actionButton (button, params, page) {
      this.$emit('action-button', button, params, page)
    }

    compositionButtons ({ button, params }) {
      this.buttonName = button.name
      this.params = params
      this.renderFileModal = true
    }
  }
export default RepresentativePage
</script>

  <style lang="stylus" >
  .containerForm-add {
    height: 190px !important;
    padding: 25px 25px;
    }

    .composition-multi-form-modal .containerForm {
    margin-top: 20px;
  }
  </style>
